// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"551da8c6","355":"a4524a49","622":"f2e6c673","832":"7fa530ca"}[chunkId] + ".chunk.js";
};